
import { DebounceTime } from '@/common/decorator';
import { ESPUField } from '@/common/enum/spu';
import { ISPUField } from '@/common/interface/spu';
import { FormModel } from 'ant-design-vue';
import { v4 } from 'uuid';
import { Vue, Component, Emit, Prop, Watch, Ref } from 'vue-property-decorator';
import AutoOffShelfTimeField from './fields/AutoOffShelfTimeField.vue';
import CategoryField from './fields/CategoryField.vue';
import ComboTotalPriceField from './fields/ComboTotalPriceField.vue';
import CommissionRatioField from './fields/CommissionRatioField.vue';
import EffectiveTimesField from './fields/EffectiveTimesField.vue';
import FilterTagField from './fields/FilterTagField.vue';
import HasNewUserPriceField from './fields/HasNewUserPriceField.vue';
import HeadlineImageField from './fields/HeadlineImageField.vue';
import HeadlineImagesField from './fields/HeadlineImagesField.vue';
import IdField from './fields/IdField.vue';
import ImagesField from './fields/ImagesField.vue';
import IntroductionField from './fields/IntroductionField.vue';
import IsAutoOffShelfField from './fields/IsAutoOffShelfField.vue';
import IsComboField from './fields/IsComboField.vue';
import IsDrawCommissionField from './fields/IsDrawCommissionField.vue';
import IsHotField from './fields/IsHotField.vue';
import KaField from './fields/KaField.vue';
import NameField from './fields/NameField.vue';
import NewUserPriceCentField from './fields/NewUserPriceCentField.vue';
import OriginalPriceCentField from './fields/OriginalPriceCentField.vue';
import ProductsField from './fields/ProductsField.vue';
import RemarkField from './fields/RemarkField.vue';
import ShortCommentField from './fields/ShortCommentField.vue';
import TempSpuShopIdsField from './fields/TempSpuShopIdsField.vue';
// import TempSpuShopPoisField from './fields/TempSpuShopPoisField.vue';
import TempSpuShopPoiNewField from './fields/TempSpuShopPoiNewField.vue';
import TyreSpecField from './fields/TyreSpecField.vue';
import TyreTagField from './fields/TyreTagField.vue';
import UnavailableTimeField from './fields/UnavailableTimeField.vue';
import VideosField from './fields/VideosField.vue';
import VipPriceCentField from './fields/VipPriceCentField.vue';
import IsAutoBrandField from './fields/IsAutoBrand.vue';
import ProductTypeField from './fields/ProductTypeField.vue';
import StockTypeField from './fields/StockTypeField.vue';
import StockCountField from './fields/StockCountField.vue';
import NoticeInfosField from './fields/NoticeInfosField.vue';
import SelfPperatedField from './fields/SelfPperatedField.vue';
import PurchasePriceField from './fields/PurchasePriceField.vue';


@Component({})
export default class SPUEditor extends Vue {
  isVisible = false;

  uuid = v4;

  rules: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [k: string]: any[];
  } = {};

  form: { [key: string]: any } | null = {};

  formItems: ISPUField[] = [];

  watchable = false;

  shouldReset = false;

  @Prop()
  title!: string;

  @Prop()
  spuType!: 'spu' | 'platformSpu' | 'kaSpu' | 'leadingSpu';

  @Prop()
  formData!: { [key: string]: any };

  @Prop()
  shopId!: any;

  @Ref()
  readonly ruleForm!: FormModel;

  get kaName() {
    return this.form;
  }

  @DebounceTime(300)
  @Watch('form', { deep: true })
  watchForm() {
    if (!this.watchable || !this.form) {
      return;
    }
    this.update();
  }
  @Emit('submit')
  submit() {
    return { ...this.form };
  }

  @Emit('update')
  update() {
    return { ...this.form };
  }


  public async callChildMethod(): Promise<boolean | undefined> {
    // 获取子组件实例
    const childComponent = this.$refs.introduction as any;
    const tempSpuShopPois = this.$refs.tempSpuShopPois as any;
    const tempSpuShopIds = this.$refs.tempSpuShopIds as any;

    const _arr: any = [];
    if (childComponent) {
      // 调用子组件的方法
      const a = await childComponent[0].myMethod() as boolean;
      const _a = a;
      _arr.push(_a);
    }
    if (tempSpuShopPois) {
      const b = await tempSpuShopPois[0].checkShop() as boolean;
      // const _b = b;
      _arr.push(b);
    }
    if (tempSpuShopIds) {
      const c = await tempSpuShopIds[0].checkShop() as boolean;
      _arr.push(c);
    }

    const _arrSet: any = [...new Set(_arr)];
    if (_arrSet.length > 1) {
      return false;
    } else {
      return _arrSet[0];
    }
  }

  public async getCreateNoPass(): Promise<boolean> {
    const tempSpuShopIds = this.$refs.tempSpuShopIds as any;
    const tempSpuShopPois = this.$refs.tempSpuShopPois as any;
    if (tempSpuShopPois) {
      const c = await tempSpuShopPois[0].getCreateNoPass() as boolean;
      return c;
    }
    if (tempSpuShopIds) {
      const c = await tempSpuShopIds[0].getCreateNoPass() as boolean;
      return c;
    }
    return false;
  }

  async onSave() {
    console.log('onSave', this.form);
    const a = await this.callChildMethod();
    if (!a) {
      // this.$message.error('校验');
      return;
    }
    const c = await this.getCreateNoPass();
    if (c) {
      this.$confirm({
        title: '门店校验提示',
        content: '未入住的门店不强制移除可继续保存',
        okText: '继续',
        okType: 'danger',
        cancelText: '取消',
        onOk: async () => {
          this.onRuleFormSubmit();
        },
        onCancel() {
          // eslint-disable-next-line no-bitwise
        },
      });
    } else {
      this.onRuleFormSubmit();
    }
    // this.ruleForm.validate((valid) => {
    //   if (valid) {
    //     this.submit();
    //   }
    // });
  }

  onRuleFormSubmit() {
    this.ruleForm.validate((valid) => {
      if (valid) {
        this.submit();
      }
    });
  }

  itemLabel(label: string) {
    if (label === 'introduction' || label === 'tempSpuShopPois' || label === 'tempSpuShopIds') {
      return label;
    }
  }

  getComponent(type: ESPUField) {
    switch (type) {
      case ESPUField.AUTO_OFF_SHELF_TIME: {
        return AutoOffShelfTimeField;
      }
      case ESPUField.CATEGORY: {
        return CategoryField;
      }
      case ESPUField.COMBO_TOTAL_PRICE: {
        return ComboTotalPriceField;
      }
      case ESPUField.EFFECTIVE_TIMES: {
        return EffectiveTimesField;
      }
      case ESPUField.FILTER_TAG: {
        return FilterTagField;
      }
      case ESPUField.HAS_NEW_USER_PRICE: {
        return HasNewUserPriceField;
      }
      case ESPUField.HEADLINE_IMAGE: {
        return HeadlineImageField;
      }
      case ESPUField.HEADLINE_IMAGES: {
        return HeadlineImagesField;
      }
      case ESPUField.ID: {
        return IdField;
      }
      case ESPUField.IMAGES: {
        return ImagesField;
      }
      case ESPUField.INTRODUCTION: {
        return IntroductionField;
      }
      case ESPUField.IS_AUTO_OFF_SHELF: {
        return IsAutoOffShelfField;
      }
      case ESPUField.IS_COMBO: {
        return IsComboField;
      }
      case ESPUField.IS_DRAW_COMMISSION: {
        return IsDrawCommissionField;
      }
      case ESPUField.IS_HOT: {
        return IsHotField;
      }
      case ESPUField.IS_PREFERRED: {
        return IsHotField;
      }
      case ESPUField.KA: {
        return KaField;
      }
      case ESPUField.NAME: {
        return NameField;
      }
      case ESPUField.NEW_USER_PRICE_CENT: {
        return NewUserPriceCentField;
      }
      case ESPUField.ORIGINAL_PRICE_CENT: {
        return OriginalPriceCentField;
      }
      case ESPUField.PRODUCTS: {
        return ProductsField;
      }
      case ESPUField.REMAK: {
        return RemarkField;
      }
      case ESPUField.SHORT_COMMENT: {
        return ShortCommentField;
      }
      case ESPUField.TEMP_SPU_SHOP_IDS: {
        return TempSpuShopIdsField;
      }
      case ESPUField.TEMP_SPU_SHOP_POIS: {
        // return TempSpuShopPoisField;
        return TempSpuShopPoiNewField;
      }
      case ESPUField.TYRE_SPEC: {
        return TyreSpecField;
      }
      case ESPUField.TYRE_TAG: {
        return TyreTagField;
      }
      case ESPUField.UNAVAILABLE_TIME: {
        return UnavailableTimeField;
      }
      case ESPUField.VIDEOS: {
        return VideosField;
      }
      case ESPUField.VIP_PRICE_CENT: {
        return VipPriceCentField;
      }
      case ESPUField.COMMISSION_RATIO: {
        return CommissionRatioField;
      }
      case ESPUField.IS_AUTO_BRAND: {
        return IsAutoBrandField;
      }
      case ESPUField.IS_AUTO_ON_SHELF: {
        return IsAutoOffShelfField;
      }
      case ESPUField.AUTO_ON_SHELF_TIME: {
        return AutoOffShelfTimeField;
      }
      case ESPUField.PRODUCT_TYPE: {
        return ProductTypeField;
      }
      case ESPUField.STOCK_TYPE: {
        return StockTypeField;
      }
      case ESPUField.STOCK_COUNT: {
        return StockCountField;
      }
      case ESPUField.NOTICE_INFOS: {
        return NoticeInfosField;
      }
      case ESPUField.SELF_OPERATED: {
        return SelfPperatedField;
      }
      case ESPUField.PURCHASE_PRICE: {
        return PurchasePriceField;
      }
      default: {
        return null;
      }
    }
  }

  setup(
    fields: ISPUField[],
    spuForm: { [key: string]: any },
    shouldResetFields?: boolean,
  ) {
    this.setRulesAndFormItems(fields);
    this.watchable = false;
    this.form = { ...spuForm };

    setTimeout(() => {
      this.watchable = true;
    }, 320);

    if (shouldResetFields) {
      this.ruleForm.resetFields();
    }
  }

  setRulesAndFormItems(fields: ISPUField[]) {
    this.formItems = [...fields];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rules: any = {};
    for (const field of fields) {
      rules[field.label] =
        field.rule && field.rule.length ? field.rule : undefined;
    }

    const ruleKeys = Object.keys(rules);
    for (const key of ruleKeys) {
      if (rules[key] === undefined) {
        delete rules[key];
      }
    }
    this.rules = rules;
    this.open();
  }

  close() {
    this.isVisible = false;
    this.reset();
  }

  open() {
    this.isVisible = true;
  }

  reset() {
    this.form = null;
    this.formItems = [];
    this.ruleForm.resetFields();
    this.$emit('reset');
  }
}
